module.exports = __webpack_public_path__ + "static/media/pfp.32ddcd14.jpg";